import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";

export const MarkdownWrap = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;
